export default __webpack_public_path__ + "static/media/icon-document.cc3507d0.svg";